import React, {useEffect, useState} from "react";
import {ipcRenderer} from "./electron-modules";
import {Dialog, DialogContent, DialogTitle, Link, Paper, Typography} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import logoPath from "./viewer/textures/misc/about-icon.png";
import manifest from "../package.json";
import clsx from 'clsx';
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";


const useStyles = makeStyles((theme) => ({
  dependencies: {
    fontSize: "18px",
    fontWeight: 500
  },
  dialog: {
    overflowY: "auto",
  },
  dialogDiv: {
    position: "fixed",
    overflowY: "auto",
    display: "block"
  },
  dialogContent: {
    textAlign: "center",
    lineHeight: 1,
    fontFamily: "sans-serif",
    overflowY: "initial"
  },
  dialogPaper: {
    overflowY: "initial",
    maxHeight: "fit-content",
    top: "65px"
  },
  divContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconButton: {
    position: 'absolute',
    right: 8,
    top: 8
  },
  indent: {
    paddingLeft: "2px"
  },
  links: {
    color: "#5c76c0"
  },
  listItems: {
    fontSize: "14px",
  },
  logoImage: {
    width: "400px",
    maxWidth: "50%"
  },
  paper: {
    overflowY: "initial"
  },
  support: {
    fontSize: "14px",
    fontWeight: 700
  },
  title: {
    fontSize: "30px",
    fontWeight: 500
  }
})
);

export const AboutDialog = () => {

  const [aboutOpen, setAboutOpen] = useState(false);

  const javascriptDependencies = {
    jquery: manifest.dependencies.jquery,
    ol: manifest.dependencies.ol,
    react: manifest.dependencies.react,
    three: manifest.dependencies.three,
    typescript: manifest.dependencies.typescript,
    electron: manifest.devDependencies.electron
  };

  // Python packages
  const pythonDependencies = {
    numpy:'1.17.1',
    scipy: '1.1.0',
    'scikit-learn': '0.20.3',
    matplotlib: '2.2.4',
    pykml: '0.1.3',
    lxml: '4.4.1'
  };

  const miscDependancies = [
    {
      "name": "detectron2",
      "version": "2.0",
      "href": 'https://github.com/facebookresearch/detectron2'
    }, {
      "name": "PotreeConvertor.exe",
      "version": "1.6",
      "href": 'https://github.com/potree/PotreeConverter'
    }, {
      "name": "laszip-cli.exe",
      "version": "3.2.9",
      "href": 'https://github.com/LASzip/LASzip'
    }, {
      "name": "pytorch",
      "version": "1.7.0",
      "href": 'https://pytorch.org/'
    }, {
      "name": "tensorboard",
      "version": "2.3.0",
      "href": 'https://www.tensorflow.org/tensorboard'
    }
  ];

  const getDependencies = () => {
    let jsDependencies = Object.keys(javascriptDependencies).map(key => {
      let data = javascriptDependencies[key];
      let version = data.replace('^', '');

      return {
        "name": key,
        "version": version,
        "href": `https://www.npmjs.com/package/${key}`
      };
    });

    let pyDependencies = Object.keys(pythonDependencies).map(key => {
      let version = pythonDependencies[key].replace('^', '');

      return {
        "name": key,
        "version": version,
        "href": `https://pypi.python.org/pypi/${key}`
      };
    });

    let final = [
      ...jsDependencies,
      ...pyDependencies,
      ...miscDependancies
    ];

    // Sort data by key
    final.sort((a, b) => {
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    });

    return final;
  };

  const classes = useStyles();
  const version = manifest.version;
  const dependencies = getDependencies();

  useEffect(() => {
    ipcRenderer?.removeAllListeners("open-about");
    ipcRenderer?.on("open-about", () => {
      setAboutOpen(true);
    });
  });

  return (
    <div className={classes.dialogDiv}>
      <Dialog classes={{ paper: classes.dialogPaper }} className={classes.dialog} fullWidth maxWidth="sm" onClose={() => {setAboutOpen(false);}} open={aboutOpen}>
        <DialogTitle id="alert-dialog-title">{"Third Party Libraries"}
          <input className={classes.iconButton} id="icon-button-file" type="button"
            hidden onClick={() => setAboutOpen(false)}/>
          <label className={classes.iconButton} htmlFor="icon-button-file">
            <IconButton color="primary" aria-label="close" component="span">
              <CloseIcon />
            </IconButton>
          </label>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Paper elevation={0} className={classes.paper}>
            <img src={logoPath} className={classes.logoImage} alt={"Solv3D Logo"}/>
          </Paper>
          <h2 className={classes.title}>SOLV3D engine viewer v{version}</h2>
          <br/>
          <strong className={classes.support} >SOLV3D Inc. Support</strong><br/>
          <div>
            <Link className={clsx(classes.links, classes.listItems)}
              href="mailto:help@solv3d.com" underline="hover" target="_blank" rel="noreferrer">
            help@solv3d.com
            </Link>
            <br/>
            <Link className={clsx(classes.links, classes.listItems)}
              href="https://solv3d.com" underline="hover" target="_blank" rel="noreferrer">
            solv3d.com
            </Link>
            <br/>
          </div>
          <h4 className={classes.dependencies}>Third Party</h4>
          {dependencies.map((item, index) => (
            <div className={classes.divContent} key={index}>
              <Link className={clsx(classes.links, classes.listItems)} href={item.href} underline="hover" target="_blank" rel="noreferrer">
                {item.name}
              </Link>
              <Typography className={clsx(classes.listItems, classes.indent)}> ({item.version})</Typography>
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </div>
  );
};